import { render, staticRenderFns } from "./location_general_params.vue?vue&type=template&id=5e77cad0&scoped=true&"
import script from "./location_general_params.vue?vue&type=script&lang=js&"
export * from "./location_general_params.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e77cad0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e77cad0')) {
      api.createRecord('5e77cad0', component.options)
    } else {
      api.reload('5e77cad0', component.options)
    }
    module.hot.accept("./location_general_params.vue?vue&type=template&id=5e77cad0&scoped=true&", function () {
      api.rerender('5e77cad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/base/location_general_tab/location_general_params.vue"
export default component.exports